import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import jwtUtil from '@/utils/jwtUtil'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/routes/HomeRoute')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/routes/LoginRoute')
    },
    {
        path: '/articles',
        name: 'Articles',
        component: () => import('@/routes/ArticleRoute')
    },
    {
        path: '/articles/:articleId/:mode',
        name: 'Article Form',
        component: () => import('@/forms/ArticleForm')
    },
    {
        path: '/articles/:mode',
        name: 'Create Article Form',
        component: () => import('@/forms/ArticleForm')
    },
    {
        path: '/newspaper',
        name: 'Newspaper',
        component: () => import('@/routes/NewspaperRoute')
    },
    {
        path: '/newspaper/:newspaperId/:mode',
        name: 'Newspaper Form',
        component: () => import('@/forms/NewspaperForm')
    },
    {
        path: '/newspaper/:mode',
        name: 'Create Newspaper Form',
        component: () => import('@/forms/NewspaperForm')
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    const currentUser = store.getters.currentUser
    const token = store.getters.getToken
    if ((!token || (token && jwtUtil.isJwtExpired(token))) && to.name !== 'Login') {
        store.dispatch('logout').then(() => next({ path: '/login' }))
    } else if (!currentUser && to.name === 'Login') {
        next()
    } else if (currentUser.role === 'admin' || (to.meta.roles && to.meta.roles.includes(currentUser.role))) {
        next()
    }
})

export default router
